import { Link } from "react-router-dom";
import { Users, Briefcase, Calendar, UserCog, UserCircle, Sparkles, CalendarCheck, CreditCard } from "lucide-react";

const AdminMenuMobileContent = () => {
  const menu = [
    {
      title: "رزرو‌ها",
      path: "/admin/appointments",
      icon: <CalendarCheck className="w-7 h-7" />,
      color: "bg-indigo-500",
      textColor: "text-indigo-600",
      bgLight: "bg-indigo-50",
    },
    {
      title: "پرداخت‌ها",
      path: "/admin/payments",
      icon: <CreditCard className="w-7 h-7" />,
      color: "bg-purple-500",
      textColor: "text-purple-600",
      bgLight: "bg-purple-50",
    },
    {
      title: "کارکنان سالن",
      path: "/admin/staff",
      icon: <Users className="w-7 h-7" />,
      color: "bg-blue-500",
      textColor: "text-blue-600",
      bgLight: "bg-blue-50",
    },
    {
      title: "خدمات سالن",
      path: "/admin/services",
      icon: <Briefcase className="w-7 h-7" />,
      color: "bg-purple-500",
      textColor: "text-purple-600",
      bgLight: "bg-purple-50",
    },
    {
      title: "تعطیلات عمومی سالن",
      path: "/admin/holidays",
      icon: <Calendar className="w-7 h-7" />,
      color: "bg-red-500",
      textColor: "text-red-600",
      bgLight: "bg-red-50",
    },
    {
      title: "کاربران",
      path: "/admin/users",
      icon: <UserCog className="w-7 h-7" />,
      color: "bg-green-500",
      textColor: "text-green-600",
      bgLight: "bg-green-50",
    },
    {
      title: "پروفایل کاربری من",
      path: "/admin/profile",
      icon: <UserCircle className="w-7 h-7" />,
      color: "bg-orange-500",
      textColor: "text-orange-600",
      bgLight: "bg-orange-50",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* هدر */}
      <div className="mb-6 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-600 shadow-lg mb-3">
          <Sparkles className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-xl font-bold text-gray-800 mb-1">پنل مدیریت</h1>
        <p className="text-xs text-gray-500">دسترسی سریع به بخش‌های مختلف</p>
      </div>

      {/* گرید منو */}
      <div className="grid grid-cols-1 gap-3 max-w-sm mx-auto">
        {menu.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className="group active:scale-95 transition-transform duration-150"
          >
            <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 active:shadow-md transition-shadow">
              <div className="flex items-center gap-4">
                {/* آیکن */}
                <div className={`flex-shrink-0 w-14 h-14 rounded-xl ${item.color} flex items-center justify-center shadow-sm`}>
                  <div className="text-white">
                    {item.icon}
                  </div>
                </div>

                {/* متن */}
                <div className="flex-1 flex items-center min-h-[56px]">
                  <h3 className={`text-base font-bold ${item.textColor}`}>
                    {item.title}
                  </h3>
                </div>

                {/* فلش */}
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* فوتر */}
      <div className="mt-8 text-center">
        <p className="text-xs text-gray-400">
          برای دسترسی به هر بخش، روی آن کلیک کنید
        </p>
      </div>
    </div>
  );
};

export default AdminMenuMobileContent;